export default "__VITE_ASSET___Bihn0vZ__"